
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { initializeProgramInDatabase } from '../../actions/index'

import { tss_target_calculate } from '../../helperFunctions/runningProgramFunctions'

import IntensityHelpModal from './IntensityHelpModal'

import { Bar } from "react-chartjs-2";
import { optionProgram ,dataProgram } from "../../variables/chartsData";



import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Jumbotron } from 'reactstrap';
import {
    FormGroup,
    Input,
    Row,
    Col,
    Progress,
  } from "reactstrap";
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

import {planPickersDataset} from '../../helperFunctions/runningProgramFunctions'

import CustomProgramPicker from './CustomProgramPicker';



const CreateProgramModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;

  const state = useSelector(state => state.auth)
  const dispatch = useDispatch()
  

  //console.log(state)
  const [modal, setModal] = useState(false);
  const [form,setForm] = useState(10)
  const [runsPerWeek,setRunsPerWeek] = useState("3")
  const [choosePlaner,setChoosePlaner] = useState("Basic plan 1 Month 1")
  const [dataPlaner,setDataPlaner] = useState("Aerobic,Aerobic,Aerobic,LongRun-Aerobic")
  const [picker1,setPicker1] = useState('Aerobic')
  const [picker2,setPicker2] = useState('Aerobic')
  const [picker3,setPicker3] = useState('Aerobic')
  const [picker4,setPicker4] = useState('Aerobic')

  const toggle = () => setModal(!modal);


  const generateProgram = () =>{
    if (choosePlaner === 'custom'){
      var program = []
      program.push(picker1,picker2,picker3,picker4)
    }
    else{
      program = dataPlaner.split(',')
    }
    
    const tss_target = tss_target_calculate(form)
    var programData = {targetForm:form,tss_target:tss_target,program_runs_per_week:runsPerWeek,runningProgram:program,planType:choosePlaner}
    
    dispatch(initializeProgramInDatabase(programData))
    //console.log(data)
    
  }
  const pickerChange = (value,id) =>{
    if (id==1){
      setPicker1(value)
    }
    if (id==2){
      setPicker2(value)
    }
    if (id==3){
      setPicker3(value)
    }
    if (id==4){
      setPicker4(value)
    }
    console.log(value,id)

  }

  const planChooseInput = (target) =>{
    setChoosePlaner(target.value)
    if (target.value.includes("Advance plan 1")){
      if (Number(runsPerWeek) <=5){
        setRunsPerWeek("5")
      }
    }
    const planPicker  = planPickersDataset(target.value)
    setDataPlaner(planPicker)
  }
  
  if (choosePlaner.includes('Basic plan 1')){
    var data = dataProgram([4,6,4,8,3,3])
    var options = optionProgram()
    var duration = 50
    var goalAerobicSpeed = 65
    var goalDistance = 60
    var goalMaxSpeed = 50
    var titleProgram = 'Basic plan 1'
  }
  else if (choosePlaner.includes('Basic plan 2')){
    var data = dataProgram([4,6,8,4,3,3])
    var options = optionProgram()
    var duration = 70
    var goalAerobicSpeed = 60
    var goalDistance = 70
    var goalMaxSpeed = 50
    var titleProgram = 'Basic plan 2'
  }
  else if (choosePlaner.includes('Advance plan 1')){
    var data = dataProgram([4,7,9,5,7,6])
    var options = optionProgram()
    var duration = 60
    var goalAerobicSpeed = 60
    var goalDistance = 60
    var goalMaxSpeed = 80
    var titleProgram = 'Advance plan 1 tempo/max speed'
  }
  else{
    var data = dataProgram([2,2,2,2,2,2])
    var options = optionProgram()
    var duration = 0
    var goalAerobicSpeed = 0
    var goalDistance = 0
    var goalMaxSpeed = 0
    var titleProgram = 'Custom'
  }
  
  return (
    <div>
      <Button color="warning" onClick={toggle}>Generate Running Program</Button>
      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Running Program</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">
            <Row>          
                <Col className="pl-4" md="12">
                <FormGroup>
                    <label>Runs per week</label>
                    <Input type="select" value={runsPerWeek} onChange={(e)=>setRunsPerWeek(e.target.value)}style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                      <option value ={3}>3</option>
                      <option value ={4}>4</option>
                      <option value ={5}>5</option>
                      <option value ={6}>6</option>
                      <option value ={7}>7</option>
                    </Input>
                </FormGroup>
                </Col>
            </Row>
            <Row>          
                <Col className="pl-4" md="12">
                <FormGroup>
                    <label>Program type</label>
                    <Input type="select" style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}} value={choosePlaner} onChange={e => planChooseInput(e.target)}>
                    <option value="custom" data-weeklist="Base,Base,Base,Base">Custom</option>
                          <optgroup style={{backgroundColor: 'rgb(34, 34, 34)',fontWeight: '600'}} label="Basic plan 1">
                            <option data-weeklist="Base,Base,Base,Base" value="Basic plan Base period">Base period (Base,Base,Base,Base)</option>
                            <option data-weeklist="Aerobic,Aerobic,Aerobic,LongRun-Aerobic" value="Basic plan 1 Month 1">Month 1 (Aerobic,Aerobic,Aerobic,LongRun-Aerobic)</option>
                            <option data-weeklist="LongRun-Aerobic,LongRun-Aerobic,LongRun-Tempo-Easy,LongRun-Tempo-Easy" value="Basic plan 1 Month 2">Month 2 (LongRun-Aerobic,LongRun-Aerobic,LongRun-Tempo-Easy,LongRun-Tempo-Easy)</option>
                            <option data-weeklist="LongRun-Tempo-Easy,LongRun-Interval-Easy,LongRun-Tempo-Easy,LongRun-Interval-Easy" value="Basic plan 1 Month 3">Month 3 (LongRun-Tempo-Easy,LongRun-Interval-Easy,LongRun-Tempo-Easy,LongRun-Interval-Easy)</option>
                          </optgroup>
                          <optgroup style={{backgroundColor: 'rgb(34, 34, 34)',fontWeight: '600'}} label="Basic plan 2">
                            <option data-weeklist="Base,Base,Base,Base" value="Basic plan Base period">Base period (Base,Base,Base,Base)</option>
                            <option data-weeklist="AerobicI,AerobicI,AerobicI,LongRun-Aerobic" value="Basic plan 2 Month 1">Month 1 (Aerobic,Aerobic,Aerobic,LongRun-Aerobic)</option>
                            <option data-weeklist="LongRun-AerobicI,LongRun-AerobicI,AerobicI-LongRun-Tempo,AerobicI-LongRun-Tempo" value="Basic plan 2 Month 2">Month 2 (LongRun-Aerobic,LongRun-Aerobic,LongRun-Tempo-Easy,LongRun-Tempo-Easy)</option>
                            <option data-weeklist="AerobicI-LongRun-Tempo,LongRun-Interval-AerobicI,AerobicI-LongRun-Tempo,LongRun-Interval-AerobicI" value="Basic plan 2 Month 3">Month 3 (LongRun-Tempo-Easy,LongRun-Interval-Easy,LongRun-Tempo-Easy,LongRun-Interval-Easy)</option>
                          </optgroup>
                          <optgroup style={{backgroundColor: 'rgb(34, 34, 34)',fontWeight: '600'}} label="Advance plan 1 tempo/max speed">
                            <option data-weeklist="Base,Base,Base,Base" value="Basic plan Base period">Base period (Base,Base,Base,Base)</option>
                            <option data-weeklist="AerobicI,AerobicI,AerobicI,LongRun-Aerobic" value="Advance plan 1 Month 1">Month 1 (Aerobic,Aerobic,Aerobic,LongRun-Aerobic)</option>
                            <option data-weeklist="LongRun-AerobicI,LongRun-AerobicI,AerobicI-LongRun-Tempo,AerobicI-LongRun-Tempo" value="Advance plan 1 Month 2">Month 2 (LongRun-Aerobic,LongRun-Aerobic,LongRun-Tempo-Easy,LongRun-Tempo-Easy)</option>
                            <option data-weeklist="AerobicI-LongRun-Tempo,LongRun-Interval-AerobicI,AerobicI-LongRun-Tempo,LongRun-Interval-AerobicI" value="Advance plan 1 Month 3">Month 3 (LongRun-Tempo-Easy,LongRun-Interval-Easy,LongRun-Tempo-Easy,LongRun-Interval-Easy)</option>
                          </optgroup>
                    </Input>
                </FormGroup>
                </Col>
            </Row>
            <Row>
              
                <Col className="pl-4" md="12">
                    <label style={{color:'rgb(48, 189, 255)'}}>Intensity factor : <span style={{color:'#F0A936'}}> {form}</span><IntensityHelpModal/></label>
                    <Slider min={5} max={25} value={form} step={1} onChange={setForm}/>
                </Col>
            </Row>
            <Row style={{padding:'30px'}}>
              <div>
                <Jumbotron className='text-info' style={{backgroundColor:'rgb(30,30,30)'}}>
                  
                  <p className="lead">{titleProgram}</p>
                  <p className="lead">
                    
                    <Bar
                        data={data}
                        options={options}
                      />
                    
                  </p>
                  <label style={{fontSize:'13px',color:'rgb(100,200,255)'}}>Activity Duration </label>
                  <Progress color="warning" value={duration} style={{height:'3px'}}/>
                  <label style={{fontSize:'13px',color:'rgb(100,200,255)'}}>Increase Distance </label>
                  <Progress color="info" value={goalDistance} style={{height:'3px'}}/>
                  <label style={{fontSize:'13px',color:'rgb(100,200,255)'}}>Increase Aerobic Speed and Capacity </label>
                  <Progress color="success" value={goalAerobicSpeed} style={{height:'3px'}}/>
                  <label style={{fontSize:'13px',color:'rgb(100,200,255)'}}>Increase Tempo/Max Speed </label>
                  <Progress color="danger" value={goalMaxSpeed} style={{height:'3px'}}/>
                  <hr className="my-2" />
                  {choosePlaner.includes('Basic plan 1') ? 
                  <div>

                  
                    <p>For runners of all levels</p>
                    <p>Better suited for runners with <span className='text-warning'>Performance Index lower than 50</span>as it consists of <span className='text success'>Aerobic II </span> runs</p>
                    <hr className="my-2" />
                    <p className='text-success'>Aerobic II runs (higher pace less duration than Aerobic I)</p>
                  </div>
                  : " "}
                  {choosePlaner.includes('Basic plan 2') ? 
                  <div>

                  
                    <p>For runners of all levels</p>
                    <p>Better suited for runners with <span className='text-warning'>Performance Index higher than 50</span>as it consists of <span className='text success'>Aerobic I </span> runs</p>
                    <hr className="my-2" />
                    <p className='text-success'>Aerobic I runs (lower pace more duration than Aerobic II)</p>
                  </div>
                  : " "}
                  {choosePlaner.includes('Advance plan 1') ? 
                  <div>

                  
                    <p className='text-warning'>For Seasoned runners</p>
                    <p>It is adviced to not just straight to this program if you don't have a good aerobic base as it contains frequent tempo/max speed activities </p>
                    <hr className="my-2" />
                    <p className='text-success'>Runs per week : at least 5</p>
                  </div>
                  : " "}
                
                  
                 
                </Jumbotron>
              </div>
            </Row>

            
            {choosePlaner =='custom' 
            ?
             <CustomProgramPicker 
              picker1={picker1} 
              picker2={picker2} 
              picker3={picker3} 
              picker4={picker4} 
              pickerChange={(picker1,id) => pickerChange(picker1,id)}
              
              /> 
              : ''}
          </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <Button color="warning" onClick={generateProgram}>Generate Program</Button>{' '}
          <Button color="danger" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default CreateProgramModal;